export default "__VITE_ASSET__CmoxmDbd__"